// extracted by mini-css-extract-plugin
module.exports = {"container":"Page404_container__3WqTP","text":"Page404_text__2e824"};